import styled from '@emotion/styled';

export const LegalPersonListPageContainer = styled.div`
  width: 100%;
  height: 100%;
`;
